import React from 'react'
import './ModeStart.sass'
import Report from '../../Report/Report'
import {Link} from "react-router-dom";

export default () => {
  const input2 = JSON.parse(localStorage.getItem('InputParams2'))

  if (!input2) {
    return (

      <React.Fragment>

        <main className="params">

          <h1 className="params__title">
            Режим резания для предварительного шлифования торцом круга
          </h1>

          <div className="params-content">

            <div className="params-content-descr error">
              Введите и сохраните исходные данные заготовки
              <br/>
              для просмотра режима резания
            </div>

          </div>

        </main>

        <Report/>

      </React.Fragment>

    )
  }


  const time = (( 2 * input2.length / 30 ) * ( input2.width / 13 ) * ( 0.12 / 0.005 )).toFixed(2)

  return (

    <React.Fragment>

      <main className="params">

        <h1 className="params__title">
          Режим резания для предварительного шлифования торцом круга
        </h1>

        <div className="params-content">

          <div className="params-content-descr mode-center">

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Скорость резания. м/c</span>
              <span className="params-label__value road-input__value mode-input__value">15...30</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Скорость детали, м/мин</span>
              <span className="params-label__value road-input__value mode-input__value">12</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Вертикальная подача, мм </span>
              <span className="params-label__value road-input__value mode-input__value">0,015</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Мощность резания, кВт</span>
              <span className="params-label__value road-input__value mode-input__value">0,51</span>

            </div>

            <div className="params-label second-input road-input">

              <span className="params-label__item road-input__item mode-input__item">Время обработки, мин</span>
              <span className="params-label__value road-input__value mode-input__value">{time}</span>

            </div>

          </div>

          <div className="mode-link">
            <Link to='/modules/mode/finish' className="mode-link__next">
            </Link>
          </div>

        </div>

      </main>

      <Report/>

    </React.Fragment>

  )
}